/**
 * Placeholder reports data. Replace with the reporting API: catalogue,
 * schedules, run history and the monthly analytics series.
 */

export const REPORT_STATS = [
  {
    key: "total",
    label: "Total Reports",
    value: "128",
    foot: "All time",
    tone: "blue",
    icon: "file",
  },
  {
    key: "generated",
    label: "Reports Generated (This Month)",
    value: "32",
    delta: "14.3%",
    foot: "vs last month",
    tone: "green",
    icon: "check",
  },
  {
    key: "scheduled",
    label: "Scheduled Reports",
    value: "8",
    foot: "Active schedules",
    tone: "amber",
    icon: "clock",
  },
  {
    key: "exports",
    label: "Exports (This Month)",
    value: "96",
    delta: "18.7%",
    foot: "vs last month",
    tone: "indigo",
    icon: "download",
  },
  {
    key: "shared",
    label: "Reports Shared (This Month)",
    value: "24",
    delta: "9.1%",
    foot: "vs last month",
    tone: "sky",
    icon: "users",
  },
];

export const REPORT_TABS = [
  "All Reports",
  "Data Quality",
  "Compliance",
  "Taxpayer",
  "Risk",
  "Operational",
];

export const TOTAL_REPORTS = 12;

export const POPULAR_REPORTS = [
  {
    id: "taxpayer-summary",
    name: "Taxpayer Summary Report",
    category: "Taxpayer",
    icon: "users",
    tone: "blue",
    description: "Summary of taxpayers by type, status and activity.",
    generated: "01 Sep 2026 10:30 AM",
  },
  {
    id: "nif-registration",
    name: "NIF Registration Report",
    category: "Operational",
    icon: "idcard",
    tone: "green",
    description: "NIF applications, approvals and rejections.",
    generated: "01 Sep 2026 09:15 AM",
  },
  {
    id: "data-quality",
    name: "Data Quality Overview",
    category: "Data Quality",
    icon: "database",
    tone: "sky",
    description: "Data quality scores, issues and trend analysis.",
    generated: "01 Sep 2026 08:45 AM",
  },
  {
    id: "risk-compliance",
    name: "Risk & Compliance Report",
    category: "Compliance",
    icon: "shield",
    tone: "amber",
    description: "Risk scores, high-risk taxpayers and issues.",
    generated: "31 Aug 2026 07:20 PM",
  },
  {
    id: "duplicate-resolution",
    name: "Duplicate Resolution Report",
    category: "Data Quality",
    icon: "link",
    tone: "indigo",
    description: "Duplicate records identified and resolved.",
    generated: "31 Aug 2026 06:10 PM",
  },
];

/**
 * Category colours come from the validated categorical set used elsewhere in
 * the app; "Other" is a neutral grey rather than a sixth hue.
 */
export const TOTAL_BY_CATEGORY = 128;

export const CATEGORY_BREAKDOWN = [
  {
    label: "Taxpayer",
    value: 32,
    share: 25.0,
    color: "#0072b2",
    legendPrimary: "32",
    legendSecondary: "(25.0%)",
  },
  {
    label: "Data Quality",
    value: 28,
    share: 21.9,
    color: "#009e73",
    legendPrimary: "28",
    legendSecondary: "(21.9%)",
  },
  {
    label: "Compliance",
    value: 24,
    share: 18.8,
    color: "#e69f00",
    legendPrimary: "24",
    legendSecondary: "(18.8%)",
  },
  {
    label: "Risk",
    value: 20,
    share: 15.6,
    color: "#cc79a7",
    legendPrimary: "20",
    legendSecondary: "(15.6%)",
  },
  {
    label: "Operational",
    value: 16,
    share: 12.5,
    color: "#d55e00",
    legendPrimary: "16",
    legendSecondary: "(12.5%)",
  },
  {
    label: "Other",
    value: 8,
    share: 6.2,
    color: "#9aa7bb",
    legendPrimary: "8",
    legendSecondary: "(6.2%)",
  },
];

export const ANALYTICS_LABELS = ["5 Aug", "12 Aug", "19 Aug", "26 Aug", "1 Sep"];

export const ANALYTICS = [
  {
    key: "generated",
    label: "Reports Generated",
    value: "32",
    delta: "14.3%",
    note: "vs last month",
    color: "#1b6fd6",
    type: "area",
    ticks: [0, 15, 30, 45],
    values: [22, 26, 24, 30, 27, 38, 29, 33, 31, 36, 34, 39, 37, 40],
  },
  {
    key: "exports",
    label: "Exports",
    value: "96",
    delta: "18.7%",
    note: "vs last month",
    color: "#26a269",
    type: "area",
    ticks: [0, 25, 50, 75, 100],
    values: [48, 54, 51, 62, 58, 70, 66, 74, 71, 79, 76, 84, 88, 95],
  },
  {
    key: "shared",
    label: "Reports Shared",
    value: "24",
    delta: "9.1%",
    note: "vs last month",
    color: "#7a4fd0",
    type: "area",
    ticks: [0, 10, 20, 30, 40],
    values: [14, 18, 15, 21, 17, 24, 19, 23, 20, 26, 22, 27, 24, 28],
  },
  {
    key: "scheduled",
    label: "Scheduled Reports",
    value: "8",
    note: "No change",
    noDelta: true,
    color: "#1b6fd6",
    type: "bar",
    ticks: [0, 5, 10, 15],
    values: [8, 9, 7, 12, 11],
  },
];

export const RECENT_REPORTS = [
  {
    id: "taxpayer-summary",
    name: "Taxpayer Summary Report",
    when: "01 Sep 2026 10:30 AM",
    icon: "users",
    tone: "blue",
    status: "Completed",
  },
  {
    id: "nif-registration",
    name: "NIF Registration Report",
    when: "01 Sep 2026 09:15 AM",
    icon: "idcard",
    tone: "green",
    status: "Completed",
  },
  {
    id: "data-quality",
    name: "Data Quality Overview",
    when: "01 Sep 2026 08:45 AM",
    icon: "database",
    tone: "sky",
    status: "Completed",
  },
  {
    id: "risk-compliance",
    name: "Risk & Compliance Report",
    when: "31 Aug 2026 07:20 PM",
    icon: "shield",
    tone: "amber",
    status: "Completed",
  },
  {
    id: "duplicate-resolution",
    name: "Duplicate Resolution Report",
    when: "31 Aug 2026 06:10 PM",
    icon: "link",
    tone: "indigo",
    status: "Completed",
  },
];

export const SCHEDULED_REPORTS = [
  {
    id: "monthly-taxpayer",
    name: "Monthly Taxpayer Summary",
    schedule: "Monthly (1st of every month)",
    delivery: "Email (PDF)",
    recipients: "5 recipients",
    lastRunDate: "01 Sep 2026",
    lastRunTime: "10:05 AM",
    nextRunDate: "01 Oct 2026",
    nextRunTime: "10:00 AM",
    status: "Active",
  },
  {
    id: "weekly-quality",
    name: "Weekly Data Quality Report",
    schedule: "Weekly (Every Monday)",
    delivery: "Email (PDF)",
    recipients: "3 recipients",
    lastRunDate: "31 Aug 2026",
    lastRunTime: "08:00 AM",
    nextRunDate: "08 Sep 2026",
    nextRunTime: "08:00 AM",
    status: "Active",
  },
  {
    id: "weekly-risk",
    name: "High Risk Taxpayers Report",
    schedule: "Weekly (Every Friday)",
    delivery: "Email (PDF)",
    recipients: "4 recipients",
    lastRunDate: "29 Aug 2026",
    lastRunTime: "05:15 PM",
    nextRunDate: "05 Sep 2026",
    nextRunTime: "05:00 PM",
    status: "Active",
  },
];

export const REPORT_ACTIONS = [
  {
    key: "create",
    title: "Create New Report",
    text: "Build a custom report with advanced filters.",
    icon: "plus",
  },
  {
    key: "templates",
    title: "Report Templates",
    text: "Use pre-built templates to save time.",
    icon: "file",
  },
  {
    key: "schedules",
    title: "Manage Schedules",
    text: "View and manage scheduled reports.",
    icon: "clock",
  },
  {
    key: "settings",
    title: "Report Settings",
    text: "Configure report preferences and defaults.",
    icon: "settings",
  },
];
